<template>
  <div v-if="current">
    
    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-12 col-sm-1">
              <v-text-field
                label="Nome"
                v-model="current.name"
                outlined
                dense
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-1">
              <v-textarea
                label="Observação"
                v-model="current.obs"
                outlined
                dense
              ></v-textarea>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="success" @click="save()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
    
    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import api from "../../api/index.js";
import router from '../../router/index.js';
export default {
  data: () => ({
    current: null,
    dialog_loading: false
  }),
  created: function () {
    this.load();
  },
  methods: {
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/plan/0", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar registro!");
          console.log(error);
        });
    },
    save: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .post("/plan", this.current, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function () {
          me.dialog_loading = false;
          alert("Plano cadastrado com sucesso!");
          router.push({ path: "/plan" });
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao salvar formulario de cadastro!");
          console.log(error);
        });
    }
  }
};
</script>